/*
 * Copyright (c) 2022 biocrates life sciences ag, All rights reserved.
 */

import {TableOption} from "./tableOption"

export interface TableFiltering<T = any> extends TableOption {
    type: TableFilteringType
    value: T
}

export enum TableFilteringType {
    // Reserved for future custom filters
    SINGLE,
    MULTI,
    RANGE,
    STRING,

    // Store simple filtering structure provided by free AG Grid (text,number,date), max 2 conditions
    AG_GRID,
}
